<template>
  <el-card class="box-card">
    <div slot="header" class="clearfix">
      <!-- 标题 -->
      <span style="font-size: 24px">审核抄送流程配置</span>
      <div class="head-text" style="float: right">
        <el-input
          placeholder="请输入"
          class="search-input"
          style="width: 300px"
          v-model="searchword"
        ></el-input>
        <el-button
          slot="append"
          icon="el-icon-search"
          class="mar-t80"
          @click="GetFormAuditFlowList"
        ></el-button>
        <el-button @click="addformShow(null)" type="primary" plain
          >新增</el-button
        >
        <!-- <el-button type="danger" plain>批量删除</el-button> -->
      </div>
    </div>

    <el-table
      height="72vh"
      align="center"
      class="table"
      :data="formAuditFlowList"
    >
      <el-table-column
        align="center"
        prop="fafl03"
        label="名称"
      ></el-table-column>
      <el-table-column align="center" label="操作">
        <template slot-scope="scope">
          <el-button
            @click="addformShow(scope.row.fafl01)"
            size="small"
            type="primary"
            plain
            >编辑</el-button
          >
          <el-button
            @click="CopyFormAuditFlow(scope.row.fafl01)"
            size="small"
            type="primary"
            plain
            >复制</el-button
          >
          <el-popconfirm
            style="margin-left: 10px"
            @confirm="DelFormAuditFlow(scope.row.fafl01)"
            title="确定删除吗？"
          >
            <el-button slot="reference" size="small" type="danger" plain
              >删除</el-button
            >
          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      align="center"
      class="mar-top20"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pageIndex"
      :page-sizes="[100, 50, 10]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    ></el-pagination>

    <!-- 添加 -->

    <el-dialog title="流程设置" :visible.sync="addformisShow" width="70%">
      <p style="color: #2a81ee; margin: 10px">定义审核流程</p>
      <el-input v-model="auditflow.fafl03"></el-input>

      <p style="color: #2a81ee; margin: 10px">审批流程</p>
      <el-descriptions
        v-for="(item, index) in detailList"
        :key="index"
        class="margin-top"
        :column="4"
        border
      >
        <el-descriptions-item>
          <template slot="label"> 流程节点 </template>
          <el-input v-model="item.fadt03" size="mini"></el-input>
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label"> 审批人 </template>
          <el-select
            filterable
            v-model="item.fadt04"
            multiple
            size="mini"
            placeholder="请选择"
          >
            <el-option
              v-for="item in userList"
              :key="item.user01"
              :label="item.user04"
              :value="item.user01"
            >
            </el-option>
          </el-select>
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label"> 审批性质 </template>
          <el-select v-model="item.fadt05" size="mini" placeholder="请选择">
            <el-option
              v-for="item in auditOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label"> 操作 </template>
          <i
            @click="add(index)"
            style="font-size: 24px; color: green; cursor: pointer"
            class="el-icon-plus"
          ></i>
          <i
            @click="del(index)"
            style="
              font-size: 24px;
              color: red;
              cursor: pointer;
              margin-left: 5px;
            "
            class="el-icon-minus"
          ></i>
          <i
            @click="gotop(index)"
            style="
              font-size: 24px;
              color: #000;
              cursor: pointer;
              margin-left: 5px;
            "
            class="el-icon-upload2"
          ></i>
          <i
            @click="gobottom(index)"
            style="
              font-size: 24px;
              color: blue;
              cursor: pointer;
              margin-left: 5px;
            "
            class="el-icon-download"
          ></i>
        </el-descriptions-item>
      </el-descriptions>
      <p style="color: #2a81ee; margin: 10px">抄送流程</p>
      <el-select filterable v-model="csUserList" multiple placeholder="请选择">
        <el-option
          v-for="item in userList"
          :key="item.user01"
          :label="item.user04"
          :value="item.user01"
        >
        </el-option>
      </el-select>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="AddOrUpdateFormAuditFlow"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </el-card>
</template>

<script>
import {
  AddOrUpdateFormAuditFlow,
  GetFormAuditFlowList,
  GetOneFormAuditFlow,
  GetProUsersList,
  DelFormAuditFlow,
  CopyFormAuditFlow,
} from "@/setAxios";
import _ from "lodash";
export default {
  data() {
    return {
      searchword: "",
      pageIndex: 1,
      pageSize: 15,
      formAuditFlowList: [],
      total: 0,
      addformisShow: false,
      auditflow: {
        fafl01: 0,
        fafl02: localStorage.xid,
        fafl03: "",
        fafl04: 0,
      },
      detailList: [
        {
          fadt01: 0,
          fadt02: 0,
          fadt03: "",
          fadt04: [],
          fadt05: "",
          fadt06: "",
          fadt07: 1,
          fadt08: new Date(),
        },
      ],
      auditOptions: [
        {
          value: 1,
          label: "会签",
        },
        {
          value: 2,
          label: "或签",
        },
      ],
      userList: [],
      csUserList: [],
      csList: null,
    };
  },
  created() {
    this.GetFormAuditFlowList();
  },
  methods: {
    addformShow(id) {
      if (id) {
        this.GetOneFormAuditFlow(id);
      }
      this.addformisShow = true;
      this.GetProUsersList();
    },
    async GetOneFormAuditFlow(id) {
      let params = {
        id,
      };
      let res = await GetOneFormAuditFlow({ params });
      this.auditflow = res.Data.auditflow;
      let filterArr = res.Data.detailList.filter((ele) => ele.fadt07 == 1);
      filterArr.forEach((ele) => {
        ele.fadt04 = ele.fadt04.split(",").map(Number);
      });
      this.detailList = filterArr;
      this.csList = res.Data.detailList.find((ele) => ele.fadt07 == 2);
      if (this.csList)
        this.csUserList = this.csList.fadt04.split(",").map(Number);
    },
    async DelFormAuditFlow(ids) {
      let res = await DelFormAuditFlow({ ids });
      if (res.Code) {
        this.$message.success("删除成功");
        this.GetFormAuditFlowList();
      }
    },
    async CopyFormAuditFlow(id) {
      let res = await CopyFormAuditFlow({ id });
      if (res.Code) {
        this.$message.success("复制成功");
        this.GetFormAuditFlowList();
      }
    },
    async AddOrUpdateFormAuditFlow() {
      let detailList2 = _.cloneDeep(this.detailList);
      if (
        !detailList2.length ||
        !detailList2.every(
          (w) => w.fadt03 != "" && w.fadt04.length && w.fadt05 != ""
        ) ||
        this.auditflow.fafl03.trim() == ""
      ) {
        this.$message.error("请完善审核流程");
        return;
      }
      detailList2.forEach((ele, index) => {
        ele.fadt04 = ele.fadt04.join(",");
        ele.fadt06 = index + 1;
      });

      if (this.csUserList.length) {
        detailList2.push({
          fadt01: this.csList ? this.csList.fadt01 : 0,
          fadt02: 0,
          fadt03: "",
          fadt04: this.csUserList.join(","),
          fadt05: "",
          fadt06: "",
          fadt07: 2,
          fadt08: new Date(),
        });
      }

      let params = {
        auditflow: this.auditflow,
        detailList: detailList2,
      };
      let res = await AddOrUpdateFormAuditFlow(params);
      if (res.Code > 0) {
        this.$message.success("添加成功");
        this.addformisShow = false;
        this.auditflow = {
          fafl01: 0,
          fafl02: localStorage.xid,
          fafl03: "",
          fafl04: 0,
        };
        this.detailList = [
          {
            fadt01: 0,
            fadt02: 0,
            fadt03: "",
            fadt04: [],
            fadt05: "",
            fadt06: "",
            fadt07: 1,
            fadt08: new Date(),
          },
        ];
        this.GetFormAuditFlowList();
      }
    },
    async GetProUsersList() {
      let params = {
        seachword: "",
        id: localStorage.xid,
        cid: localStorage.pid,
        bid: "null",
        pageIndex: 1,
        pageSize: 999999,
      };
      let res = await GetProUsersList({ params });
      this.userList = res.Data.list;
    },
    async GetFormAuditFlowList() {
      let params = {
        xid: localStorage.xid,
        searchword: this.searchword,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
      };
      let res = await GetFormAuditFlowList({ params });
      this.formAuditFlowList = res.Data.list;
      this.total = res.Data.total;
    },
    add(index) {
      this.detailList.splice(index + 1, 0, {
        fadt01: 0,
        fadt02: 0,
        fadt03: "",
        fadt04: [],
        fadt05: "",
        fadt06: "",
        fadt07: 1,
        fadt08: new Date(),
      });
    },
    del(index) {
      if (this.detailList.length == 1) {
        this.$message.warning("至少存在一个");
      } else {
        this.detailList.splice(index, 1);
      }
    },
    gotop(index) {
      if (index == 0) {
        this.$message.warning("已经在顶点");
      } else {
        let obj = _.cloneDeep(this.detailList[index]);
        this.detailList[index] = _.cloneDeep(this.detailList[index - 1]);
        this.detailList[index - 1] = obj;
        this.$forceUpdate();
      }
    },
    gobottom(index) {
      if (index == this.detailList.length - 1) {
        this.$message.warning("已经在底部");
      } else {
        let obj = _.cloneDeep(this.detailList[index]);
        this.detailList[index] = _.cloneDeep(this.detailList[index + 1]);
        this.detailList[index + 1] = obj;
        this.$forceUpdate();
      }
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.GetFormAuditFlowList();
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.GetFormAuditFlowList();
    },
  },
};
</script>

<style scoped></style>
